import { maybe } from "@saleor/misc";
import { useTableStyles } from "@saleor/remittanceRunner/styles/tableStyles";
import React from "react";

interface RemittanceRunnerTblColMallProp {
  mall: string;
}

export const RemittanceRunnerTblColMall: React.FC<RemittanceRunnerTblColMallProp> = props => {
  const { mall } = props;
  const tblClasses = useTableStyles(props);

  return (
    <div className={tblClasses.dataGroup}>
      <div className={tblClasses.dataTitle}>Mall</div>
      <div className={tblClasses.dataDisplay}>
        {maybe(() => mall) ? <span>{mall}</span> : <span>-----</span>}
      </div>
    </div>
  );
};

export default RemittanceRunnerTblColMall;
